export enum ENotification {
  getNotification = 'notification/getList',
  init = 'notification/init',
  shownNotification = 'notification/shownNotification',

  actionedNotification = 'notification/actioned'
}
